import { render, staticRenderFns } from "./QuickTour.vue?vue&type=template&id=6732b052"
import script from "./QuickTour.vue?vue&type=script&lang=js"
export * from "./QuickTour.vue?vue&type=script&lang=js"
import style0 from "./QuickTour.vue?vue&type=style&index=0&id=6732b052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports